{
  "achievementCenter": "اچیومنٹ سینٹر",
  "achievementCenterSubtitle": "Badges unlock کریں، XP earn کریں، level grow کریں اور اپنی Exalt Exchange identity بنائیں۔",
  "badges": "Badges",
  "bearish": "Bearish",
  "bullish": "Bullish",
  "buy": "خریدیں",
  "comment": "تبصرہ",
  "commentAddedSuccessfully": "تبصرہ کامیابی سے شامل ہوگیا۔",
  "commentFailed": "کمنٹ ناکام",
  "communityFeed": "کمیونٹی فیڈ",
  "communityPosts": "کمیونٹی پوسٹس",
  "completedTrades": "Completed Trades",
  "copyCode": "کوڈ کاپی کریں",
  "copyLink": "لنک کاپی کریں",
  "createSignalPost": "سگنل / مارکیٹ پوسٹ بنائیں",
  "currentLevel": "Current Level",
  "displayName": "ڈسپلے نیم",
  "disputes": "Disputes",
  "exaltTrader": "EXALT ٹریڈر",
  "failedCreatePost": "پوسٹ بنانے میں ناکامی",
  "failedLoadAchievements": "کامیابیاں لوڈ کرنے میں ناکامی۔",
  "failedLoadReputation": "شہرت لوڈ کرنے میں ناکامی۔",
  "failedLoadSocialTrading": "سوشل ٹریڈنگ لوڈ نہیں ہو سکی",
  "failedRefreshAchievements": "کامیابیاں تازہ کرنے میں ناکامی۔",
  "failedRefreshReputation": "شہرت تازہ کرنے میں ناکامی۔",
  "follow": "فالو",
  "followFailed": "فالو ناکام",
  "followers": "فالوورز",
  "following": "فالو کر رہے ہیں",
  "fraudFlags": "Fraud Flags",
  "goldBadges": "گولڈ بیجز",
  "joinExaltUsingReferral": "میرے ریفرل کوڈ کے ساتھ Exalt Exchange میں شامل ہوں اور ٹریڈنگ شروع کریں۔",
  "joined": "شامل ہوئے",
  "levelProgress": "Level Progress",
  "levelProgressText": "اگلی سطح تک پہنچنے کے لیے XP کمانا جاری رکھیں۔",
  "like": "لائک",
  "likeFailed": "لائک ناکام",
  "loading": "لوڈ ہو رہا ہے...",
  "loadingAchievementCenter": "کامیابی مرکز لوڈ ہو رہا ہے...",
  "loadingQr": "QR کوڈ لوڈ ہو رہا ہے...",
  "loadingReputationCenter": "شہرت مرکز لوڈ ہو رہا ہے...",
  "loadingSocialTrading": "سوشل ٹریڈنگ لوڈ ہو رہی ہے...",
  "locked": "Locked",
  "low": "کم",
  "myTraderProfile": "میرا ٹریڈر پروفائل",
  "neutral": "غیر جانبدار",
  "noAchievementProfileFound": "کوئی کامیابی پروفائل نہیں ملا۔",
  "noBadgesYet": "ابھی کوئی badges نہیں۔ Badges unlock کرنے کے لیے activity بڑھائیں۔",
  "noPostsYet": "ابھی کوئی پوسٹ نہیں۔",
  "noReferralRewardsYet": "ابھی تک کوئی ریفرل انعام نہیں۔",
  "noReferredMembersYet": "آپ نے ابھی تک کسی کو ریفر نہیں کیا۔",
  "noReputationHistoryYet": "ابھی تک کوئی شہرت کی تاریخ نہیں۔",
  "noReputationProfileFound": "کوئی شہرت پروفائل نہیں ملا۔",
  "noTraders": "کوئی تاجر نہیں ملا۔",
  "noTradersFound": "کوئی ٹریڈر نہیں ملا۔",
  "p2pOrders": "P2P Orders",
  "p2pRating": "P2P Rating",
  "pair": "Pair",
  "platinum": "پلاٹینم",
  "postCreatedSuccessfully": "پوسٹ کامیابی سے بن گئی۔",
  "posting": "پوسٹ ہو رہی ہے...",
  "previous": "پچھلا",
  "profitLoss": "منافع / نقصان",
  "publishPost": "پوسٹ پبلش کریں",
  "referralCodeCopied": "ریفرل کوڈ کاپی ہو گیا۔",
  "referralLinkCopied": "ریفرل لنک کاپی ہو گیا۔",
  "referralLoadFailed": "ریفرل ڈیٹا لوڈ کرنے میں ناکامی۔",
  "referralQrCode": "ریفرل QR کوڈ",
  "referralReward": "ریفرل انعام",
  "referralRewardHistory": "ریفرل انعام کی تاریخ",
  "referredUser": "ریفر کردہ صارف",
  "refreshAchievements": "کامیابیاں تازہ کریں",
  "refreshScore": "اسکور تازہ کریں",
  "reputationCenter": "کمیونٹی ریپوٹیشن سسٹم",
  "reputationCenterSubtitle": "Trading trust، P2P success، verified badges اور community activity کے ساتھ اپنی Exalt identity بنائیں۔",
  "reputationHistory": "شہرت کی تاریخ",
  "reputationScore": "Reputation Score",
  "searchYourMembers": "نام یا ای میل کے ذریعے اپنے ممبران تلاش کریں",
  "sell": "فروخت کریں",
  "send": "بھیجیں",
  "sentiment": "جذبات",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "shareMarketViewPlaceholder": "مارکیٹ ویو، ٹریڈنگ سیٹ اپ، EXALT اپڈیٹ یا سگنل شیئر کریں...",
  "shareReferralLink": "ریفرل لنک شیئر کریں",
  "signal": "سگنل",
  "socialTradingSubtitle": "ماہر ٹریڈرز کو فالو کریں، مارکیٹ آئیڈیاز شیئر کریں، سگنلز دیکھیں اور EXALT کمیونٹی کے ساتھ بڑھیں۔",
  "socialTradingTitle": "سوشل ٹریڈنگ",
  "topTraders": "ٹاپ ٹریڈرز",
  "topTradersLeaderboard": "ٹاپ ٹریڈرز لیڈر بورڈ",
  "totalComments": "کل کمنٹس",
  "totalEarnings": "کل کمائی",
  "totalLikes": "کل لائکس",
  "totalReferrals": "کل ریفرلز",
  "totalTraders": "کل ٹریڈرز",
  "totalXp": "Total XP",
  "tradeType": "ٹریڈ کی قسم",
  "tradingSuccess": "Trading Success",
  "unfollow": "ان فالو کریں",
  "unlocked": "Unlocked",
  "username": "صارف نام",
  "verified": "ویریفائیڈ",
  "winRate": "جیت کی شرح",
  "writeBeforePosting": "پوسٹ کرنے سے پہلے کچھ لکھیں۔",
  "writeComment": "کمنٹ لکھیں...",
  "yourReferralCode": "آپ کا ریفرل کوڈ",
  "yourReferralLink": "آپ کا ریفرل لنک",
  "yourReferredMembers": "آپ کے حوالہ کردہ ممبران"
}